import { Text, VStack } from '@ayble-health/dashboard-components';
import React from 'react';
import moment from 'moment-timezone';
import { Box } from '@chakra-ui/react';
import { useDashboardPageState } from '../../hooks/useDashboardPageState';
import { useAffiliate } from '../../api/affiliates/useAffiliate';
import { Loader } from '../Loader';

const THIRD_PARTY_SUBSCRIPTIONS = ['sub_covered', 'sub_test'];

export const UserSubscription = () => {
  const {
    state: { user },
  } = useDashboardPageState();

  const {
    affiliate,
    isInitialLoading: isAffiliateLoading,
    isLoading: isFetchingAffiliate,
  } = useAffiliate({
    affiliateId: user?.affiliate,
  });

  if (user?.affiliate && (isFetchingAffiliate || isAffiliateLoading)) {
    return (
      <Box py={6}>
        <Loader loading={true} />
      </Box>
    );
  }
  if (!user) return null;

  const { address_state, id, plan_name, subscription_id, timezone } =
    user;
  const shortTimezone = moment().tz(timezone).zoneAbbr();
  const subscription = affiliate
    ? `${affiliate.name} (${
        subscription_id === 'sub_covered' ? 'Verified' : 'Not Verified'
      })`
    : !!subscription_id &&
      !THIRD_PARTY_SUBSCRIPTIONS.includes(subscription_id) &&
      plan_name;

  const accountType =
    subscription_id === 'sub_covered'
      ? 'covered by Health Plan (B2B)'
      : 'Stripe Subscription (D2C)';

  const healthPlanMemberId =
      user.health_plan_member_id ? user.health_plan_member_id : '--'

  return (
    <VStack>
      <Text
        color={'blueGray.600'}
        fontSize={'md'}
        fontWeight={'normal'}
        textAlign="left"
      >
        Subscription &amp; Account
      </Text>

      <Text
        color={'secondary.200'}
        fontSize={'md'}
        fontWeight={'bold'}
        mt={1}
        textAlign="left"
      >
        {subscription}, {accountType}
      </Text>

      <Text
        color={'secondary.200'}
        fontSize={'md'}
        fontWeight={'bold'}
        mt={1}
        textAlign="left"
      >
        Health Plan ID: {healthPlanMemberId}
      </Text>

      <Text
        color={'secondary.200'}
        fontSize={'md'}
        fontWeight={'bold'}
        mt={1}
        textAlign="left"
      >
        {address_state} ({shortTimezone})
      </Text>

      <Text
        color={'secondary.200'}
        fontSize={'md'}
        fontWeight={'bold'}
        mt={1}
        textAlign="left"
      >
        User ID: {id}
      </Text>
    </VStack>
  );
};
